<div class="tag" [class.tag--active]="active()">
  @if(icon()){
  <div class="tag__icon">
    <ng-container *ngComponentOutlet="icon()"></ng-container>
  </div>
  }
  <span> {{label()}} </span>
</div>
